import styled from '@emotion/styled';
import { SuccessModal } from '@liveoptics/react-ui';
import React from 'react';
import { VerifyOwnerState } from '../../../enums/VerifyOwnerState';

export interface VerifyOwnerSuccessModalProps {
  state: VerifyOwnerState;
  email?: string;
  isReassign?: boolean;
  onClose: () => void;
}
const Message = styled.span`
  line-height: 22px;
`;

const Email = styled.span`
  font-weight: 600;
  line-height: 22px;
`;

export const VerifyOwnerSuccessModal = (props: VerifyOwnerSuccessModalProps) => {
  const getTitle = () => {
    const action = props.isReassign ? 'Reassigned' : 'Verified';

    switch (props.state) {
      case VerifyOwnerState.VerifyDell:
        return `${action} Owner`;
      case VerifyOwnerState.SetDeal:
        return `${action} Deal ID`;
      case VerifyOwnerState.VerifyEndUserAndSetOpportunity:
        return `${action} Owner and Opportunity`;
      case VerifyOwnerState.VerifyEndUser:
        return `${action} Owner`;
      case VerifyOwnerState.SetOpportunity:
        return `${action} Opportunity`;
      default:
        return '';
    }
  };

  const getMessage = () => {
    const action = props.isReassign ? 'reassigned' : 'verified';

    switch (props.state) {
      case VerifyOwnerState.VerifyDell:
        return <Message>Owner has been {action} successfully.</Message>;
      case VerifyOwnerState.SetDeal:
        return <Message>Deal ID has been {action} successfully.</Message>;
      case VerifyOwnerState.VerifyEndUserAndSetOpportunity:
        return (
          <>
            <Message>
              Owner and Opportunity have been {action} successfully to following user.
            </Message>
            <br />
            <Email>{props.email}</Email>
          </>
        );
      case VerifyOwnerState.VerifyEndUser:
        return (
          <>
            <Message>Owner has been {action} successfully to following user.</Message>
            <br />
            <Email>{props.email}</Email>
          </>
        );
      case VerifyOwnerState.SetOpportunity:
        return <Message>Opportunity has been {action} successfully.</Message>;
      default:
        return '';
    }
  };

  return (
    <SuccessModal
      title={getTitle()}
      successMessage=""
      primaryButtonName="Ok"
      onClose={props.onClose}
      onPrimaryClick={props.onClose}
    >
      {getMessage()}
    </SuccessModal>
  );
};
